import { uploadCSV } from "@/api/csvService";

export default {
  //Upload csv
  async uploadCSV({ commit, rootState }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      rootState.loading.uploadCSVBtn.load = true;
      rootState.loading.uploadCSVBtn.disabled = true;
      const response = await uploadCSV(payload);
      const csvs = response.data.data.records;
      commit("SET_CSV_DATA", csvs);
      commit("SET_CSV_RECORDS", response.data.data.totalRecords);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "File processed!",
          color: "success",
        },
        { root: true }
      );
      rootState.loading.uploadCSVBtn.load = false;
      rootState.loading.uploadCSVBtn.disabled = false;
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.error,
          color: "error",
        },
        { root: true }
      );
      rootState.loading.uploadCSVBtn.load = false;
      rootState.loading.uploadCSVBtn.disabled = false;
    }
  },
};
